export default "__VITE_ASSET__CObb2ypj__"